(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-70816-product"]) return;
  try {
    
document.addEventListener('change',event=>{const input=event.target;const root=input.closest('.hm-70816-product');if(!root)return;if(input.matches('select[name="id"]')){const option=input.selectedOptions[0];if(option.dataset.price)root.querySelector('.hm-70816-price').textContent=option.dataset.price;const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState(null,'',url);}if(input.matches('.hm-nq-units input')){const guide=input.closest('.hm-nq-guide');guide.querySelectorAll('[data-cm]').forEach(cell=>{cell.textContent=input.value==='in'?(Number(cell.dataset.cm)/2.54).toFixed(1):cell.dataset.cm;});guide.querySelector('[data-hm-unit]').textContent=input.value==='in'?'in':'cm';}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-80225-product"]) return;
  try {
    
document.querySelectorAll('.hm80225').forEach(root=>{root.querySelectorAll('[data-gallery]').forEach(button=>button.addEventListener('click',()=>{const hero=root.querySelector('.hc-hero');hero.src=button.dataset.gallery;hero.alt=button.querySelector('img').alt;root.querySelector('[data-enlarge]').href=button.dataset.gallery;root.querySelectorAll('[data-gallery]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}));root.querySelectorAll('[data-unit]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelectorAll('[data-cm]').forEach(c=>c.textContent=button.dataset.unit==='cm'?c.dataset.cm:(Number(c.dataset.cm)/2.54).toFixed(1));root.querySelectorAll('[data-unit-label]').forEach(c=>c.textContent=button.dataset.unit);}));const select=root.querySelector('select[name=id]');if(select)select.addEventListener('change',()=>{const o=select.selectedOptions[0],b=root.querySelector('[data-add]');root.querySelector('[data-price]').textContent=o.dataset.price;b.disabled=o.dataset.available!=='true';b.textContent=b.disabled?b.dataset.soldLabel:b.dataset.addLabel;const u=new URL(location.href);u.searchParams.set('variant',o.value);history.replaceState({},'',u);});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-80236c-product"]) return;
  try {
    
document.querySelectorAll('.hc').forEach(root=>{root.querySelectorAll('[data-gallery]').forEach(button=>button.addEventListener('click',()=>{const hero=root.querySelector('.hc-hero');hero.src=button.dataset.gallery;hero.alt=button.querySelector('img').alt;root.querySelector('[data-enlarge]').href=button.dataset.gallery;root.querySelectorAll('[data-gallery]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}));root.querySelectorAll('[data-unit]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelectorAll('[data-cm]').forEach(c=>c.textContent=button.dataset.unit==='cm'?c.dataset.cm:(Number(c.dataset.cm)/2.54).toFixed(1));root.querySelectorAll('[data-unit-label]').forEach(c=>c.textContent=button.dataset.unit);}));const select=root.querySelector('select[name=id]');if(select)select.addEventListener('change',()=>{const o=select.selectedOptions[0],b=root.querySelector('[data-add]');root.querySelector('[data-price]').textContent=o.dataset.price;b.disabled=o.dataset.available!=='true';b.textContent=b.disabled?b.dataset.soldLabel:b.dataset.addLabel;const u=new URL(location.href);u.searchParams.set('variant',o.value);history.replaceState({},'',u);});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-bt-product"]) return;
  try {
    
document.querySelectorAll('.hm-bt-buy select').forEach(select=>select.addEventListener('change',()=>{const option=select.selectedOptions[0];if(option.dataset.price)select.closest('.hm-bt-buy').querySelector('.hm-bt-price').textContent=option.dataset.price;}));
document.addEventListener('change', event => {
  const input = event.target;
  if (!input.matches('.hm-bt-product .hm-bt-fit-units input')) return;
  const guide = input.closest('.hm-bt-fit-guide');
  const inches = input.value === 'in';
  guide.querySelectorAll('[data-cm]').forEach(cell => {
    const cm = Number(cell.dataset.cm);
    cell.textContent = inches ? (cm / 2.54).toFixed(1) : String(cm);
  });
  guide.querySelector('[data-hm-unit]').textContent = inches ? 'in' : 'cm';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-qa-product"]) return;
  try {
    
document.querySelectorAll('.hm-qa-buy select').forEach(select=>select.addEventListener('change',()=>{const option=select.selectedOptions[0];if(option.dataset.price)select.closest('.hm-qa-buy').querySelector('.hm-qa-price').textContent=option.dataset.price;}));
document.addEventListener('change', event => {
  const input = event.target;
  if (!input.matches('.hm-qa-product .hm-qa-fit-units input')) return;
  const guide = input.closest('.hm-qa-fit-guide');
  const inches = input.value === 'in';
  guide.querySelectorAll('[data-cm]').forEach(cell => {
    const cm = Number(cell.dataset.cm);
    cell.textContent = inches ? (cm / 2.54).toFixed(1) : String(cm);
  });
  guide.querySelector('[data-hm-unit]').textContent = inches ? 'in' : 'cm';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm70641-pdp"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',e=>{const r=e.target.closest('.hm70641');if(!r)return;if(e.target.matches('[data-units]')){r.querySelectorAll('[data-cm]').forEach(c=>c.textContent=e.target.value==='in'?(Number(c.dataset.cm)/2.54).toFixed(1):c.dataset.cm);r.querySelector('[data-unit-label]').textContent=e.target.value;}if(e.target.matches('select[name="id"]')){const o=e.target.selectedOptions[0];r.querySelector('[data-price]').textContent=o.dataset.price;const u=new URL(location.href);u.searchParams.set('variant',e.target.value);history.replaceState(null,'',u);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
